<template>
  <div v-cloak class="flex flex-col min-h-screen h-screen">
    <layout-dynamic-region region="banner" />
    <slot name="header" />
    <slot name="mainContent">
      <main class="bg-ngray-6 w-full overflow-auto px-6 pt-4 flex flex-col flex-fill-height gap-4">
        <section v-if="$slots.subHeader" class="flex flex-col">
          <slot name="subHeader" />
        </section>
        <section class="relative flex flex-col flex-fill-height bg-white rounded-lg p-1 layout-wrapper">
          <slot />
        </section>
      </main>
    </slot>
    <slot name="footer" />
    <global-notification-bar />
    <wait-overlay />
  </div>
</template>

<style scoped>
.layout-wrapper {
  container: layout-wrapper/inline-size;
}
</style>
